import React, { forwardRef } from 'react';
import { SvgIcon } from '@material-ui/core';

const InfoIcon = forwardRef((props, ref) => (
  <SvgIcon viewBox="0 0 21.81 21.81" {...props} ref={ref}>
    <path
      d="M11.467.563a10.9,10.9,0,1,0,10.9,10.9A10.906,10.906,0,0,0,11.467.563Zm0,4.837A1.847,1.847,0,1,1,9.621,7.246,1.847,1.847,0,0,1,11.467,5.4ZM13.93,16.568a.528.528,0,0,1-.528.528H9.533A.528.528,0,0,1,9,16.568V15.513a.528.528,0,0,1,.528-.528h.528V12.171H9.533A.528.528,0,0,1,9,11.643V10.588a.528.528,0,0,1,.528-.528h2.814a.528.528,0,0,1,.528.528v4.4H13.4a.528.528,0,0,1,.528.528Z"
      transform="translate(-0.563 -0.563)"
    />
  </SvgIcon>
));

export default InfoIcon;
